import $ from 'jquery';

if ( $('.consultation-filters').length ) {

  var filters = {};
  var filterTargetClones = $( '.filter-target' ).clone();
  var filterTargetsContainer = $( '.filter-target' ).parent();

  // Initialize filters with current values
  $( '.consultation-filters .components-table-filter' ).each( function ( i, el ) {

    var $input = $( this );
    var value = $input.val();
    var name = $input.data( 'filterColumn' );

    filters[name] = value;

  });

  // Trigger filtering on filter change
  $( '.consultation-filters .components-table-filter' ).on( 'change', function ( i, el ) {

    var $input = $( this );
    var value = $input.val();
    var name = $input.data( 'filterColumn' );

    if ( $input.hasClass( 'components-table-filter-dropdown' ) ) {

      var $label = $input.prev( 'label' );
      var label = $( 'option:selected', $input ).text();

      $label.html( label );

    }

    filters[ name ] = value;

    filterConsultationTargets( filters );

  });

  /* eslint-disable */
  // Handle filtering
  function filterConsultationTargets( filters ) {

    var attrs = [];

    $.each( filters, function ( name, value ) {

      if ( value != '' ) {

        attrs.push( '[data-' + name + '*="' + value + '"]' );

      }

    });

    // changed the functionality so that instead of hiding all and showing the matches
    // the container is emptied and populated with clones of matches (from clones of originals stored in filterTargetClones).
    // This way the css nth-child selector works as expected and clear:left works.

    filterTargetsContainer.empty();
    filterTargetsContainer.append(filterTargetClones.filter('.filter-target' + attrs.join()).clone());

    //    $( '.filter-target' ).hide();
    //    $( '.filter-target' + attrs.join()).show();

  }
  /* eslint-enable */

  filterConsultationTargets( filters );

}
